// components/SpinnerOverlay.js
/* eslint-disable react/prop-types */
const SpinnerOverlay = ({ isLoading }) => {
  return (
    isLoading ? (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="w-12 h-12 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
      </div>
    ) : null
  );
};

export default SpinnerOverlay;
